<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn icon fab dark small color="success" v-on="on" title="Syncronizar">
                <v-icon>sync</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-btn icon @click.native="toggleDialog" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Sincronizar Despesas</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat @click.native="sync" :disabled="syncing" :loading="syncing">Sincronizar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text v-if="!syncing">
                Deseja sincronizar as despesas cadastradas offline?
                <br/>
                (marcadas com <v-icon small color="warning">sync_problem</v-icon>)
                <br/>
                <br/>
                <b>Atenção!</b> É necessário aguardar a conclusão da sincronia.
                <br/>
                <br/>
            </v-card-text>
            <v-card-text v-if="syncing">
                Por favor, aguarde...
            </v-card-text>
            <v-progress-linear indeterminate color="primary darker-1" class="mb-0" v-if="syncing"></v-progress-linear>
        </v-card>
    </v-dialog>
</template>

<script>
import PouchDB from 'pouchdb-browser';
import Util    from '@/util';

let despesasDB = new PouchDB('despesas');

export default {
    name    : 'DespesasSyncModal',
    props   : {
        reloadGrid: Function
    },
    methods : {
        toggleDialog() {
            this.dialog = !this.dialog;
        },
        sync() {
            this.syncing = true;

            despesasDB.allDocs({include_docs: true, descending: true}, function(err, doc) {
                if (err) {
                    console.error('erro [allDocs()]', err);
                }
                console.log('doc [allDocs()]', doc);
            }).then(despesasOff => {
                console.log('despesasOff', despesasOff.rows);
                if (despesasOff.total_rows === 0) {
                    this.reloadGrid();
                    this.toggleDialog();
                    window.getApp.snackbar = {
                        show  : true,
                        color : 'warning',
                        text  : 'Não há nada para sincronizar!'
                    };
                } else {
                    const categorias = this.$offlineStorage.get('categorias');
                    let done = 0;
                    despesasOff.rows.forEach(item => {
                        const objDespesa = {
                            relatorio  : item.doc.relatorio,
                            categoria  : item.doc.categoria,
                            dt_despesa : item.doc.dt_despesa,
                            valor      : item.doc.valor,
                            obs        : item.doc.obs,
                            status     : item.doc.status,
                            img_nf     : item.doc.img_nf
                        }
                        console.log('onlineSave(objDespesa)', objDespesa);
                        this.$axios.post('despesas', objDespesa).then(response => {
                            console.info('despesa sincronizada', response);
                            console.log('remove(item.doc)', item.doc);
                            despesasDB.remove(item.doc._id, item.doc._rev);
                        });
                        done++;
                        if (done === despesasOff.rows.length) {
                            this.reloadGrid();
                            this.toggleDialog();
                            window.getApp.snackbar = {
                                show  : true,
                                color : 'green',
                                text  : 'Sincronizado com sucesso!'
                            };
                        }
                    });
                }
            }).catch(error => {
                console.error(error);
                const errorMsg = Util.getErrorMsg(error.response.data);
                this.toggleDialog();
                setTimeout(this.reloadGrid(), 3000);
                window.getApp.snackbar = {
                    show  : true,
                    color : 'red',
                    text  : `Ocorreu um erro durante a sincronia: ${errorMsg.msg}`
                };
            }).finally(() => {
                this.syncing = false;
            });
        }
    },
    data() {
        return {
            dialog  : false,
            syncing : false
        };
    },
    // mounted() {}
};
</script>
